import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "verticallyrelativeto"
    }}>{`VerticallyRelativeTo`}</h1>
    <p>{`The vertical alignment point of an anchored object.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`COLUMN_EDGE`}</strong>{` = 1095787375`}</p>
      <p parentName="blockquote">{`Align the anchored object to the edge of the text or table column.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TEXT_FRAME`}</strong>{` = 1954051174`}</p>
      <p parentName="blockquote">{`Align the anchored object to the edge of the text frame.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PAGE_MARGINS`}</strong>{` = 1095789927`}</p>
      <p parentName="blockquote">{`Align the anchored object to the page margin.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PAGE_EDGE`}</strong>{` = 1095790695`}</p>
      <p parentName="blockquote">{`Align the anchored object to the edge of the page.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LINE_BASELINE`}</strong>{` = 1096180321`}</p>
      <p parentName="blockquote">{`Align the anchored object to the baseline of the line of text.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LINE_XHEIGHT`}</strong>{` = 1096185960`}</p>
      <p parentName="blockquote">{`Align the anchored object to the top of lower case letters with no ascent, such as x.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LINE_ASCENT`}</strong>{` = 1096180083`}</p>
      <p parentName="blockquote">{`Align the anchored object to the top of the tallest letters in the text.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CAPHEIGHT`}</strong>{` = 1096185955`}</p>
      <p parentName="blockquote">{`Align the anchored object to the top of capital letters.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TOP_OF_LEADING`}</strong>{` = 1096180332`}</p>
      <p parentName="blockquote">{`Align the anchored object to the top of the text leading.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`EMBOX_TOP`}</strong>{` = 1096181101`}</p>
      <p parentName="blockquote">{`Align the anchored object to the top of the embox.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`EMBOX_MIDDLE`}</strong>{` = 1096183117`}</p>
      <p parentName="blockquote">{`Align the anchored object to the middle of the embox.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`EMBOX_BOTTOM`}</strong>{` = 1096183106`}</p>
      <p parentName="blockquote">{`Align the anchored object to the bottom of the embox.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      